import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import Context from '../../provider';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconShare from '../../assets/hkdc/icons/ShareIcon';
import QRCode from 'react-qr-code';
import React, { useContext, useEffect } from 'react';
import Slide from '@mui/material/Slide';
import qs from 'qs';
import './index.scss';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

export default function UserInfoDialog() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const { init, me, dispatch, userInfo, isMobile } = useContext(Context);

    // This page only allow logged in user
    useEffect(() => {
        if (init) {

        }
    }, [init, me, navigate, userInfo]);

    const handleClose = () => {
        dispatch({ type: 'SWITCH_USER_INFO', payload: { open: false } });
    };

    const share = () => {
        const url = document.querySelector('link[rel=canonical]') ?
            document.querySelector('link[rel=canonical]').href :
            document.location.href;

        if (navigator.share) {
            console.log('支持 Web Share API');
            navigator.share({
                title: 'HKDC Fans and Fellows',
                url: url,
                text: t('share.text').replace('{referral_code}', me?.loyalty_account?.unique_id)
              }).then(() => {
                console.log('Thanks for sharing!');
              }).catch((error) => {
                console.error('Sharing error', error);
              });
          } else {
            console.log('不支持 Web Share API');

            let copy_text = t('share.text').replace('{referral_code}', me?.loyalty_account?.unique_id);
            // 使用Clipboard API复制文本到剪贴板中
            navigator.clipboard.writeText(copy_text).then(() => {
                dispatch({
                    type: 'SET_ERROR_DIALOG',
                    payload: { open: true, title: '复制成功' }
                  });
            }).catch((err) => {
                dispatch({
                    type: 'SET_ERROR_DIALOG',
                    payload: { open: true, title: '失败', message: err.message }
                  });
            });
        }
    };

    const resolve = (url, params) => {
        const queryString = qs.stringify(params);
        const urlObj = new URL(url);
        urlObj.search += urlObj.search.startsWith('?') ? '&' : '?' + queryString;
        return urlObj.href;
    };

    return (
        <React.Fragment>
            <Dialog
                className={`${isMobile ? 'mobile' : 'web'}-user-card`}
                open={userInfo.open}
                onClose={handleClose}
                TransitionComponent={Transition}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    <div className="title-text">{t('member-code.title')}</div>
                </DialogTitle>
                <DialogContent>
                    <QRCode className='qrcode' size={200} value={me?.loyalty_account?.unique_id} />
                    <div className="desc-cont">
                        <div className="desc-text">{t('member-code.desc')}</div>
                        <div className="id-cont">
                            <div className="id-text">{me?.loyalty_account?.unique_id}</div>
                            <IconShare onClick={(e) => {
                                e.stopPropagation();
                                share();
                            }} />
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <div
                        className="btn-cont"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleClose();
                        }}
                    >
                        <CloseIcon />
                    </div>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}